export default "__VITE_ASSET__DJfR$ZFv__"